import Markets from "./jsons/Markets.json";
import { Currency } from "./types";

const DEMO_CATEGORIES: Currency[] = Markets.map((item) => ({
  ...item,
  taxonomy: "category",
}));

const DEMO_TAGS: Currency[] = Markets.map((item) => ({
  ...item,
  taxonomy: "tag",
}));

export { DEMO_CATEGORIES, DEMO_TAGS };